module.exports = __webpack_public_path__ + "img/b_LbNorm_2.cae73449.jpeg";